<template>
    <div>
        <ContactModal :companyName="contact.companyName" :jobTitle="contact.job_title" :show="showModal" @hideModal="hideModal">
            <template v-slot:icon>
                <div class="logo" v-if="!isFileRequest">
                    <img class="img-logo" src="../../assets/Group300.png"/>
                </div>
            </template>
            <template v-slot:content>
                <div class="swal-content mt-4" style="text-align: center;">
                    <div class="content-detail mt-2">
                        <h3>{{headerText}}</h3>
                        <p class="mt-2" v-if="!fileRequest || questionRequest">{{detailText}}</p>
                    </div>
                    <div class="file-detail mt-2" v-if="isFileRequest">
                        <p class="mt-4" style="color: red; font-weight: bold;font-size: 18px;">{{ fileDetailText }}</p>
                            <ul>
                                <li  v-for="(item,index) in contact.file_upload_request" :key="index" style="text-align: left;">{{ item }}</li>
                            </ul>
                    </div>
                    <div class="button-container mt-4">
                        <button class="btn" :class="proceedClass" @click="proceed()">{{proceedText}}</button>
                    </div>
                </div>
            </template>
        </ContactModal>
    </div>
</template>

<script>
import ContactModal from './ContactModal.vue';
export default {
    name: 'ContactConfirmation',
    props: ['contact', 'showModal'],
    components: { ContactModal },
    data() {
        return {
            question: '',
            openConfirmationModal: false,
            // isQuestionRequest: false,
        }
    },
    computed: {
        proceedClass() {
            if(this.fileRequest && ( this.userResponse !== '質問' && this.userResponse !== '応募見合わせ')) {
                return 'btn-red'
            } else {
                return 'btn-info'
            }
        },
        isFileRequest(){
            const {fileRequest, questionRequest, refrain } = this;
            return fileRequest && !questionRequest && !refrain;
        },
        questionRequest(){
            return  this.contact.user_response === '質問';
        },
        refrain() {
            return this.contact.user_response === '応募見合わせ';
        },
        fileRequest(){
            if(this.contact.file_upload_request.length > 0 ){
                return true;
            } else {
                return false;
            }
        },
        userResponse() {
            if ( this.contact.user_response === '応募見合わせ' ){
                return '応募見合わせ';
            } else if (this.contact.user_response === '質問'){
                return '質問';
            } else if (this.contact.contact_type === 'カジュアル面談') {
                return 'カジュアル面談';
            } else if (this.contact.contact_type === '面接案内'){
                return '面接参加';
            } else if(this.contact.contact_type === '応募案内') {
                return '選考応募'
            }
        },
        submitText(){
            if(this.contact.user_response === '応募見合わせ') {
                return '今回は控える'
            } else if(this.contact.user_response === '質問') {
                return '質問する'
            } else if(this.contact.contact_type === '面接案内'){
                return 'カジュアル面談に\r\n参加する'
            } else if(this.contact.contact_type === 'カジュアル面談') {
                return '<span style="font-size:12px">選考に応募して</span><br/><span>面接に参加する</span>';
            } else {
                return '<span style="font-size:12px">応募回答画面に</span><br/><span>進む</span>'
            }   
        },
        detailText(){
            // console.log(this.contact.user_response);
            if(this.refrain) {
                return '';
            } else if(this.contact.user_response === '質問' ) {
                return '回答をお待ちください'
            } else if(this.contact.contact_type === '応募案内'){
                return '書類選考結果は企業から直接メールで届きます';
            } else if (this.contact.contact_type === 'カジュアル面談') {
                return 'カジュアル面談実施にあたり、詳細案内は企業から直接メールで届きます';
            } else if (this.contact.contact_type === '面接案内') {
                return '面接の詳細案内は企業から直接メールで届きます';
            } else {
                return ''
            }   
        },
        fileDetailText(){
            if (this.contact.user_response === '選考応募') {
                return '手続きに必要な以下書類をマイページに登録してください'
            } else if (this.contact.user_response === 'カジュアル面談') { 
                return 'カジュアル面談実施にあたり、以下をマイページに登録する必要があります'
            } else if (this.contact.user_response === '面接参加'){
                return '面接参加にあたって、以下をマイページに登録する必要があります'
            }
        },
        replyClass(){
            if(this.questionRequest) {
                return 'btn btn-info-blue'
            }else {
                return 'btn btn-info'
            }
        },
        headerText(){
            if(this.refrain) {
                return '応募見合わせを受け付けました'
            } else if(this.questionRequest) {
                return '質問を受け付けました'
            } else if(this.contact.contact_type === '応募案内'){
                return '応募を受け付けました';
            } else if (this.contact.contact_type === 'カジュアル面談') {
                return 'カジュアル面談への応募を受け付けました';
            } else if (this.contact.contact_type === '面接案内') {
                return '面接への応募を受け付けました';
            } else {
                return '応募を受け付けました';
            }   
        },
        proceedText(){
            if(this.fileRequest && ( this.userResponse !== '質問' && this.userResponse !== '応募見合わせ')) {
                return '登録する'
            } else {
                return 'メッセージ一覧に戻る'
            }
        }
    },
    methods: {
        hideModal(){
            this.question = ''
            this.$emit('hideModal');
        },
        proceed() {
            let redirectToProfile = false;  
            if(this.fileRequest && ( this.userResponse !== '質問' && this.userResponse !== '応募見合わせ')){
                redirectToProfile = true;
            }
            this.hideModal();
            this.$nextTick(() => {
                this.$emit('redirectToContactList', redirectToProfile)
            });
        },
        async replyToContact(){
            try {
                this.$emit('submitForm',{user_response: this.userResponse, user_question: this.question});
                // this.question=''
                // const token = await this.$auth.getToken();
                // const headers = {
                //     Authorization: `Bearer ${token}`,
                // };
                // const contact = await this.axios({
                //     method: 'put',
                //     url: Api.url(Api.endpoints.reply),
                //     headers: headers,
                //     data: {
                //         question: this.question
                //     }
                // });   
                // if(contact) {
                    // this.openConfirmationModal = true;
                    // this.hideModal();
                // }
                // console.log(contact.data);
            } catch (err){
                console.log(err);
            } 
        }
    },
    mounted(){
        // console.log(this.contact);
        // this.$refs.contactModal.show();
    }
}
</script>

<style scoped>
.btn-red {
    background-color: #EB5757;
    color: #fff;
}

.btn-info {
    background-color: #006C6B;
}

.btn-info-blue {
    background-color: #2F80ED;
    color: #fff;
}

.btn {
    border-radius: 4px;
    font-weight: bold;
}
h3{
    font-weight: bold;
    font-size: 20px;
}
ul{
    padding: 0px !important;
}
ul li{
    font-weight: bold;
}
.file-detail {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.logo{
    text-align: center;
}

.img-logo{
    margin-bottom: 20px;
}
</style>